/**
 * Created by r4zi4l on 23.08.2021
 */

WorkerView.prototype.miningEffects = function () {
    return cleverapps.skins.getSlot("miningEffects") || {
        animation: "chop",
        effect: "mining.start"
    };
};

WorkerView.prototype.buildingEffects = function () {
    return {
        effect: "mining.wondermerge.build"
    };
};
